var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" container pt-4"},[_c('div',{staticClass:"text-xs-center"},[_c('h1',{staticClass:"display-3"},[_vm._v("404 Page not found")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_c('router-link',{staticClass:"btn btn-primary btn-lg",attrs:{"to":'/' + _vm.$i18n.locale()}},[_vm._v("Back")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b09f250e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error/404.vue
// module id = null
// module chunks = 